// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"6c15574fbd1a930d","888":"4617524883a9d4ee"}[chunkId] + ".css";
};